//@ts-ignore 
const reqSvgs = require.context('@/assets/slices/', true, /(\.png|\.gif|\.svg)$/);
const allSvgFilepaths = reqSvgs.keys();
const imageState = {};
allSvgFilepaths.forEach((imagePath) => {
    const image = reqSvgs(imagePath);
    imageState[`${imagePath.replace('./', 'slices/')}`] = image
})
export default imageState